import React from 'react';
import '@/assets/styles/components/button.styles.scss';
import ReactPlaceholder from 'react-placeholder';
import { CustomPlaceholderTypes } from './CustomPlaceholder.types.ts';
import { RectShape } from 'react-placeholder/lib/placeholders';
import { isString } from '@/utility';

export const CustomPlaceholder: CustomPlaceholderTypes = ({ children, className = '', type, width = '100%', height = '100%', borderRadius = '7px', rows, ready, ...props }) => {
	if (rows && rows > 0 && type === 'rect') {
		const CustomRectPlaceholder = (
			<div
				className="my-awesome-placeholder"
				style={{
					height: height,
					width: width,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between'
				}}>
				{Array.from({ length: rows || 0 }, (_, i) => (
					<RectShape
						key={i}
						color="var(--surface-cdcdcd)"
						style={{
							borderRadius: borderRadius,
							width: width,
							height: isString(height) ? (parseInt(height as string) / (rows + 1)).toString() + '%' : (height as number) / (rows + 1)
						}}
					/>
				))}
			</div>
		);

		return (
			<ReactPlaceholder
				className={className}
				style={{ width, height, borderRadius: borderRadius }}
				ready={ready}
				{...props}
				showLoadingAnimation={true}
				customPlaceholder={CustomRectPlaceholder}>
				{children}
			</ReactPlaceholder>
		);
	}

	return (
		<ReactPlaceholder
			className={className}
			style={{ width, height, borderRadius: borderRadius }}
			ready={ready}
			type={type}
			showLoadingAnimation={true}
			{...props}>
			{children}
		</ReactPlaceholder>
	);
};
